import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-4 mb-2 gap-2 mt-3" }
const _hoisted_2 = { class: "col-span-2 flex flex-col" }
const _hoisted_3 = { class: "col-span-2 flex flex-col" }
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = { class: "col-span-4 flex flex-col w-full" }
const _hoisted_9 = { class: "col-span-2 flex flex-col w-full" }
const _hoisted_10 = { class: "col-span-2 flex flex-col" }
const _hoisted_11 = {
  key: 0,
  class: "col-span-2 flex flex-col"
}
const _hoisted_12 = { class: "border text-xs border-next-dark-gray px-2 rounded-sm mr-2" }
const _hoisted_13 = { class: "text-sm border rounded-sm p-1" }
const _hoisted_14 = { class: "ml-2" }
const _hoisted_15 = {
  key: 1,
  class: "col-span-2 flex flex-col"
}
const _hoisted_16 = { class: "border text-xs border-next-dark-gray px-2 rounded-sm mr-2" }
const _hoisted_17 = { class: "text-sm border rounded-sm p-1" }
const _hoisted_18 = { class: "ml-2" }
const _hoisted_19 = {
  key: 2,
  class: "col-span-2 flex flex-col"
}
const _hoisted_20 = { class: "border text-xs border-next-dark-gray px-2 rounded-sm mr-2" }
const _hoisted_21 = { class: "text-sm border rounded-sm p-1" }
const _hoisted_22 = { class: "ml-2" }
const _hoisted_23 = { class: "flex items-end justify-end gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_MultiselectOption = _resolveComponent("MultiselectOption")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.visible) = $event)),
    backdrop: true
  }, {
    header: _withCtx(() => _cache[14] || (_cache[14] = [
      _createElementVNode("div", null, [
        _createElementVNode("h2", { class: "text-2xl font-bold" }, "Filtri avanzati")
      ], -1)
    ])),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Field, {
            modelValue: _ctx.anno,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:anno', $event))),
            field_name: "Anno",
            placeholder: "Anno"
          }, null, 8, ["modelValue"])
        ], 512), [
          [_vShow, _ctx.anno != null]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Field, { field_name: "Business unit" }, {
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                modelValue: _ctx.buAutocomplete.selection,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.buAutocomplete.selection) = $event)),
                options: _ctx.buAutocomplete.options,
                placeholder: "Business unit",
                class: "next-vue-multiselect-single",
                "track-by": "id",
                label: "nome",
                selectLabel: "",
                deselectLabel: "",
                selectedLabel: "",
                "internal-search": false,
                "close-on-select": false,
                "clear-on-select": true,
                onSearchChange: _ctx.buAutocomplete.search
              }, {
                tag: _withCtx(({option, remove}) => [
                  _createVNode(_component_MultiselectOption, {
                    onRemove: ($event: any) => (remove(option))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(option.nome), 1)
                    ]),
                    _: 2
                  }, 1032, ["onRemove"])
                ]),
                _: 1
              }, 8, ["modelValue", "options", "onSearchChange"])
            ]),
            _: 1
          })
        ], 512), [
          [_vShow, _ctx.bu != null]
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Field, {
            field_name: "Inizio dal",
            type: "date",
            modelValue: _ctx.data_inizio_dal,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:data_inizio_dal', $event)))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Field, {
            field_name: "Inizio al",
            type: "date",
            modelValue: _ctx.data_inizio_al,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:data_inizio_al', $event)))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Field, {
            field_name: "Fine dal",
            type: "date",
            modelValue: _ctx.data_fine_dal,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:data_fine_dal', $event)))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Field, {
            field_name: "Fine al",
            type: "date",
            modelValue: _ctx.data_fine_al,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:data_fine_al', $event)))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Field, {
            field_name: "Cliente/committente",
            placeholder: "Cliente/committente"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                onSearchChange: _ctx.clienteAutocomplete.search,
                loading: _ctx.clienteAutocomplete.isLoading,
                options: _ctx.clienteAutocomplete.options,
                modelValue: _ctx.clienteAutocomplete.selection,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.clienteAutocomplete.selection) = $event)),
                "track-by": "id",
                label: "denominazione",
                class: "next-vue-multiselect-single",
                placeholder: "Cliente",
                deselectLabel: "Deseleziona",
                selectedLabel: "Selezionato",
                selectLabel: "Seleziona"
              }, {
                noResult: _withCtx(() => _cache[15] || (_cache[15] = [
                  _createTextVNode("Nessun elemento trovato.")
                ])),
                singleLabel: _withCtx(({option}) => [
                  _createTextVNode(_toDisplayString(`${option.denominazione} - ${option.ragione_sociale}`), 1)
                ]),
                option: _withCtx(({option}) => [
                  _createTextVNode(_toDisplayString(`${option.denominazione} - ${option.ragione_sociale}`), 1)
                ]),
                _: 1
              }, 8, ["onSearchChange", "loading", "options", "modelValue"])
            ]),
            _: 1
          })
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Field, {
            field_name: "Azieda del gruppo",
            placeholder: "Azieda del gruppo"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                onSearchChange: _ctx.aziendaGruppoAutocomplete.search,
                loading: _ctx.aziendaGruppoAutocomplete.isLoading,
                options: _ctx.aziendaGruppoAutocomplete.options,
                modelValue: _ctx.aziendaGruppoAutocomplete.selection,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.aziendaGruppoAutocomplete.selection) = $event)),
                "track-by": "id",
                label: "nome",
                class: "next-vue-multiselect-single",
                placeholder: "Azienda del gruppo",
                deselectLabel: "Deseleziona",
                selectedLabel: "Selezionato",
                selectLabel: "Seleziona"
              }, null, 8, ["onSearchChange", "loading", "options", "modelValue"])
            ]),
            _: 1
          })
        ], 512), [
          [_vShow, _ctx.azienda_gruppo != null]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_10, [
          _createVNode(_component_Field, { field_name: "Stato" }, {
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                modelValue: _ctx.statoAutocomplete.selection,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.statoAutocomplete.selection) = $event)),
                options: _ctx.statoAutocomplete.options,
                placeholder: "Stato",
                class: "next-vue-multiselect-single",
                "track-by": "id",
                label: "descrizione",
                selectLabel: "",
                deselectLabel: "",
                selectedLabel: "",
                "internal-search": true,
                "close-on-select": true,
                "clear-on-select": true,
                onSearchChange: _ctx.statoAutocomplete.search
              }, null, 8, ["modelValue", "options", "onSearchChange"])
            ]),
            _: 1
          })
        ], 512), [
          [_vShow, _ctx.stato != null]
        ]),
        (_ctx.accounts != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_Field, { field_name: "Account" }, {
                default: _withCtx(() => [
                  _createVNode(_component_VueMultiselect, {
                    searchable: true,
                    loading: _ctx.accountsAutocomplete.isLoading,
                    "internal-search": false,
                    trackBy: "id",
                    label: "nome",
                    onSearchChange: _ctx.accountsAutocomplete.search,
                    modelValue: _ctx.accountsAutocomplete.selection,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.accountsAutocomplete.selection) = $event)),
                    options: _ctx.accountsAutocomplete.options,
                    multiple: true,
                    "close-on-select": true,
                    "clear-on-select": true,
                    class: "next-vue-multiselect",
                    placeholder: "Account",
                    deselectLabel: "Deseleziona",
                    selectedLabel: "Selezionato",
                    selectLabel: "Seleziona"
                  }, {
                    noResult: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createTextVNode("Nessun elemento trovato.")
                    ])),
                    noOptions: _withCtx(() => _cache[17] || (_cache[17] = [
                      _createTextVNode("Digita per cercare")
                    ])),
                    tag: _withCtx(({option, remove}) => [
                      _createVNode(_component_MultiselectOption, {
                        onRemove: ($event: any) => (remove(option))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_12, _toDisplayString(option.bu_label || ' '), 1),
                          _createElementVNode("span", null, _toDisplayString(option.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["onRemove"])
                    ]),
                    option: _withCtx(({option}) => [
                      _createElementVNode("span", null, [
                        _createElementVNode("span", _hoisted_13, _toDisplayString(option.bu_label), 1),
                        _createElementVNode("span", _hoisted_14, _toDisplayString(option.name), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["loading", "onSearchChange", "modelValue", "options"])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.pm != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(_component_Field, { field_name: "PM" }, {
                default: _withCtx(() => [
                  _createVNode(_component_VueMultiselect, {
                    searchable: true,
                    loading: _ctx.pmAutocomplete.isLoading,
                    "internal-search": false,
                    trackBy: "id",
                    label: "nome",
                    onSearchChange: _ctx.pmAutocomplete.search,
                    modelValue: _ctx.pmAutocomplete.selection,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.pmAutocomplete.selection) = $event)),
                    options: _ctx.pmAutocomplete.options,
                    multiple: true,
                    "close-on-select": true,
                    "clear-on-select": true,
                    class: "next-vue-multiselect",
                    placeholder: "PM",
                    deselectLabel: "Deseleziona",
                    selectedLabel: "Selezionato",
                    selectLabel: "Seleziona"
                  }, {
                    noResult: _withCtx(() => _cache[18] || (_cache[18] = [
                      _createTextVNode("Nessun elemento trovato.")
                    ])),
                    noOptions: _withCtx(() => _cache[19] || (_cache[19] = [
                      _createTextVNode("Digita per cercare")
                    ])),
                    tag: _withCtx(({option, remove}) => [
                      _createVNode(_component_MultiselectOption, {
                        onRemove: ($event: any) => (remove(option))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_16, _toDisplayString(option.bu_label || ' '), 1),
                          _createElementVNode("span", null, _toDisplayString(option.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["onRemove"])
                    ]),
                    option: _withCtx(({option}) => [
                      _createElementVNode("span", null, [
                        _createElementVNode("span", _hoisted_17, _toDisplayString(option.bu_label), 1),
                        _createElementVNode("span", _hoisted_18, _toDisplayString(option.name), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["loading", "onSearchChange", "modelValue", "options"])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.direttori != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createVNode(_component_Field, { field_name: "Produzione" }, {
                default: _withCtx(() => [
                  _createVNode(_component_VueMultiselect, {
                    modelValue: _ctx.direttoriAutocomplete.selection,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.direttoriAutocomplete.selection) = $event)),
                    options: _ctx.direttoriAutocomplete.options,
                    multiple: true,
                    onSearchChange: _ctx.direttoriAutocomplete.search,
                    "close-on-select": true,
                    placeholder: "Produzione",
                    deselectLabel: "Deseleziona",
                    selectedLabel: "Selezionato",
                    selectLabel: "Seleziona",
                    class: "next-vue-multiselect",
                    "track-by": "id",
                    label: "name"
                  }, {
                    noResult: _withCtx(() => _cache[20] || (_cache[20] = [
                      _createTextVNode("Nessun elemento trovato.")
                    ])),
                    noOptions: _withCtx(() => _cache[21] || (_cache[21] = [
                      _createTextVNode("Digita per cercare")
                    ])),
                    tag: _withCtx(({option, remove}) => [
                      _createVNode(_component_MultiselectOption, {
                        onRemove: ($event: any) => (remove(option))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_20, _toDisplayString(option.bu_label || ' '), 1),
                          _createElementVNode("span", null, _toDisplayString(option.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["onRemove"])
                    ]),
                    option: _withCtx(({option}) => [
                      _createElementVNode("span", null, [
                        _createElementVNode("span", _hoisted_21, _toDisplayString(option.bu_label), 1),
                        _createElementVNode("span", _hoisted_22, _toDisplayString(option.name), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options", "onSearchChange"])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_NextButton, {
          variant: "primary",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('update:visible', false))),
          class: "px-4 h-10"
        }, {
          default: _withCtx(() => _cache[22] || (_cache[22] = [
            _createTextVNode(" Applica ")
          ])),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}